import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import plugin from "@/plugin";
import i18n from "./i18n";
// 引入动态调整字体大小的脚本 ---------- 此处去除，字体的大小由css直接设置
// import "./rem.js";
// 动画效果
import "animate.css";
// 状态管理
import store from "@/store/index.js";
// 字体
import "@/assets/fonts/fonts.css";
// 字体图标
import "@/assets/iconfont/iconfont.css";
// 样式重置
import "@/assets/style/scss/reset.scss";
// 全局组件
import "@/components/index";
// 组件隐藏样式
import "element-ui/lib/theme-chalk/display.css";
import "element-ui/lib/theme-chalk/index.css";
import 'element-ui/lib/theme-chalk/base.css';
// 全局方法
import commonFunc from "@/utils/common.js";
for (const [key, func] of Object.entries(commonFunc)) {
  Vue.prototype[`$${key}`] = func;
}
// 配置
import config from './config'
Vue.prototype.$config = config

// 核心插件
Vue.use(plugin);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
